module.exports = __webpack_public_path__ + "img/02-min.7fc33fcf.jpg";